export const urlQueryStringToObj = (str: string) => {
  const toReturn: Record<string, string> = {};
  new URLSearchParams(str).forEach((value, key) => {
    toReturn[key] = value;
  });
  return toReturn;
};
